export enum Title {
  SYSTEM_NURSING_INTERVENTIONS = 'System Nursing Interventions'
}
